import $ from 'jquery';
import slick from 'slick-carousel';

class Slider {
    constructor() {
        console.log('Slider has bem initiated...');

        let slides = 1;

        $('.slider .items').each(function () {
            $(this).on('init', function (event, slick) {
                let totalPages = Math.ceil(slick.$slides.length / slides);
                $(this).closest('.slider').find('.total').text(totalPages >= 10 ? totalPages : '0' + totalPages);
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                let currentPage = Math.ceil((nextSlide + 1) / slides)
                $(this).closest('.slider').find('.current').text(currentPage >= 10 ? currentPage : '0' + currentPage);
            }).slick({
                slidesToShow: slides,
                slidesToScroll: slides,
                arrows: true,
                prevArrow: $(this).closest('.slider').find('.prev'),
                nextArrow: $(this).closest('.slider').find('.next'),
                variableWidth: true,
                rows: 0
            });
        });
    }
}

export default Slider;